import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/[lang]/(main)/layout.tsx\",\"import\":\"Noto_Sans\",\"arguments\":[{\"subsets\":[\"cyrillic\",\"cyrillic-ext\",\"devanagari\",\"greek\",\"greek-ext\",\"latin\",\"latin-ext\",\"vietnamese\"],\"variable\":\"--font-family-var\",\"display\":\"swap\"}],\"variableName\":\"sen\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/common/RenderGA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/CookieBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/FooterNav.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/styles/globals.css");
